
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'тест',
	'visualizationSlideoutTitle': 'Визуализации',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Введите число',
	'maxValuePlaceholder': 'Введите число',
	'customRangeErrorMessage': 'Значение должно быть числом',
	'propFillColor': 'Цвет заливки',
	'propBorderColor': 'Цвет рамки',
	'propColorPalette': 'Текущая цветовая палитра',
	'propColorPaletteChangeLabel': 'Изменить цветовую палитру',
	'propNewColorPaletteLabel': 'Создать пользовательскую палитру цветов',
	'propNewHeatPaletteLabel': 'Создать пользовательскую тепловую палитру',
	'propDonutRadius': 'Радиус кольца',
	'showTitleLabel': 'Показать заголовок',
	'titleTypeLabel': 'Тип заголовка',
	'smartTitleLabel': 'Интеллектуальный заголовок',
	'customTitleLabel': 'Пользовательский заголовок',
	'noTitleLabel': 'Без заголовка',
	'propHeatScalePalette': 'Текущая тепловая палитра',
	'propHeatPaletteChangeLabel': 'Изменить тепловую палитру',
	'propMaintainAxisScales': 'Управление масштабом оси',
	'propLineAndSymbolColor': 'Цвет линии и символа',
	'propLineAndSymbolPalette': 'Цветовая палитра линии и символа',
	'propElementColor': 'Цвет элемента',
	'propColumnColor': 'Цвет столбца',
	'propColumnPalette': 'Цветовая палитра столбца',
	'propColumnHeatPalette': 'Тепловая палитра столбца',
	'propBarColor': 'Цвет столбца',
	'propGoalColor': 'Цвет объекта назначения',
	'propToColor': 'К цвету',
	'propFromColor': 'От цвета:',
	'propNumberValidationErrorMessageId': 'Введите число',
	'fontSizeAuto': 'Автоматически',
	'propAutoBinCount': 'Число групп',
	'propAutoBinToggle': 'Автогруппирование',
	'tabName_general': 'Общие',
	'tabName_visDetails': 'Сведения',
	'tabName_animation': 'Анимация',
	'tabName_mediaDetails': 'Сведения о носителе',
	'tabName_webDetails': 'Сведения о веб-странице',
	'tabName_imageDetails': 'Сведения об изображении',
	'tabName_visualization': 'Визуализация',
	'tabName_text': 'Текстовый',
	'sectionName_colorsAndThemes': 'Цвет и темы',
	'sectionName_appearance': 'Вид',
	'sectionName_general': 'Общие',
	'sectionName_colorPalette': 'Цвет',
	'sectionName_axis': 'Ось',
	'sectionName_axis_label': 'Ось',
	'sectionName_legend': 'Легенда',
	'sectionName_chart': 'Диаграмма',
	'sectionName_regionLayer': 'Слой регионов',
	'sectionName_pointLayer': 'Слой точек',
	'sectionName_latLongLayer': 'Слой широты/долготы',
	'sectionName_pathLayer': 'Слой пути',
	'sectionName_xAxis': 'Ось x',
	'sectionName_yAxis': 'Ось y',
	'sectionName_xAxis_title': 'Заголовок оси X',
	'sectionName_yAxis_title': 'Заголовок оси Y',
	'sectionName_xAxis_label': 'Метка оси X',
	'sectionName_yAxis_label': 'Метка оси Y',
	'sectionName_column_yAxis': 'Ось Y столбца',
	'sectionName_column_yAxis_label': 'Метка оси Y столбца',
	'sectionName_column_yAxis_title': 'Заголовок оси Y столбца',
	'sectionName_line_yAxis': 'Ось Y линии',
	'sectionName_line_yAxis_label': 'Метка оси Y линии',
	'sectionName_line_yAxis_title': 'Заголовок оси Y линии',
	'sectionName_title': 'Заголовок',
	'sectionName_dataValueLabels': 'Метки значений данных',
	'sectionName_style': 'Стиль',
	'propTransparencyDescription': 'Сделайте объект более или менее прозрачным. Введите значение от 0 до 100',
	'smart_annotation_unauthorized': 'Аннотации: несанкционированный доступ',
	'smart_annotation_method': 'Аннотации: метод не разрешен',
	'smart_annotation_media': 'Аннотации: тип носителя не разрешен',
	'smart_annotation_input': 'Аннотации: недопустимый ввод',
	'smart_annotation_internal': 'Аннотации: внутренняя системная ошибка',
	'smart_annotation_generic_error': 'Аннотации: ошибка службы',
	'smart_annotation_dialog_title': 'Интуитивное понимание',
	'smart_annotation_Show_Insights': 'Показать взгляд изнутри',
	'smart_annotation_Relationship': 'Взаимосвязь:',
	'forecast_enter_number': 'Введите число между ',
	'and': ' и ',
	'smart_errors': 'Ошибки аннотации:',
	'smart_warnings': 'Предупреждения аннотации:',
	'smart_annotation_insight_icon_title': 'Интуитивное понимание',
	'smart_annotations_toggle_on': 'Включить интуитивное понимание',
	'smart_annotations_toggle_off': 'Выключить интуитивное понимание',
	'smart_annotation_toggle_on': 'Включить',
	'smart_annotation_toggle_off': 'Выключить',
	'smart_annotation_insight_unavailable': 'Интуитивное понимание сейчас недоступно',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Интуитивное понимание недоступно, когда применяется фильтр Первые или последние %',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Прогноз недоступен, если применяется фильтр  Первые или последние %',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Интуитивное понимание недоступно, когда применяется фильтр Первые или последние и поле содержит несколько столбцов',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Прогноз недоступен, если применяется фильтр Первые или последние и поле содержит несколько столбцов',
	'forecast_title': 'Прогноз',
	'forecast_show': 'Показывать прогноз',
	'forecast_toggle_on': 'Включить прогнозирование',
	'forecast_toggle_off': 'Выключить прогнозирование',
	'statDetailsPerspectiveTitle': 'Анализ',
	'emptyStatDetailsPanel': 'Для текущей визуализации никакого дополнительного анализа нет.',
	'predict_errors': 'Ошибки анализа',
	'predict_warnings': 'Предупреждения анализа',
	'fpd_invalid_data_source': 'У этого источника данных нет связанных модулей smarts',
	'fpd_network_issue': 'При выполнении анализа этого источника данных возникла ошибка',
	'fpd_data_source_category': 'Нет модуля Smarts',
	'fpd_response_errors': 'Ошибки рекомендуемого фактора',
	'fpd_response_warnings': 'Предупреждения рекомендуемого фактора',
	'catalyst_service_bad_request': 'Недопустимое требование',
	'catalyst_service_unkown_Id': 'Обнаружен неизвестный ID требования',
	'catalyst_service_internal_server_error': 'Внутренняя ошибка сервера',
	'catalyst_service_generic_error': 'Ошибка службы Catalyst',
	'catalyst_service_error': 'Эта служба сейчас недоступна',
	'propLegendPosition': 'Положение легенды',
	'propLeft': 'Слева',
	'propRight': 'Справа',
	'propTop': 'Вверху',
	'propBottom': 'Внизу',
	'propNone': 'Нет',
	'propLegendDisplay': 'Показать легенду',
	'targetThicknessPlaceHolder': '%{min} до %{max}',
	'targetThicknessErrorMsg': 'Введите целое число от %{min} до %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Драйверы (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'выбрано)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Сброс к значениям по умолчанию',
	'possibelKeyDriver_AddNewDrivers': 'Добавить еще драйверов',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Поиск для добавления драйверов',
	'possibleKeyDrivers_MaxPossibleReached': 'Отмените выбор некоторых драйверов, чтобы добавить или выбрать других',
	'possibleKeyDrivers_Recommended': 'Рекомендуется',
	'visRecommendedTypes': 'Рекомендуемые типы визуализации',
	'visRecommender_smartsfailure': 'в настоящее время рекомендации по визуализации недоступны',
	'visMore': 'Еще...',
	'visMoreTooltip': 'Дополнительные визуализации',
	'visOtherTypes': 'Другие типы визуализации',
	'visChange': 'Изменить визуализацию',
	'automaticTypeCaption': 'Автоматически',
	'propVisType': 'Типы визуализации',
	'dlg_loading': 'Загрузка...',
	'snippetListChartCaption': 'Список отрывков',
	'convoClusterChartCaption': 'Кластер обмена данными',
	'areaChartCaption': 'Диаграмма с областями',
	'barChartCaption': 'Горизонтальная столбчатая диаграмма',
	'columnChartCaption': 'Гистограмма',
	'stackedbarChartCaption': 'Составная горизонтальная столбчатая диаграмма',
	'stackedcolumnChartCaption': 'Составная вертикальная столбчатая диаграмма',
	'bubbleChartCaption': 'Пузырьковая диаграмма',
	'marimekkoChartCaption': 'Диаграмма Маримекко',
	'cometChartCaption': 'Анализ драйвера',
	'scatterChartCaption': 'Диаграмма рассеивания',
	'lineChartCaption': 'Линия',
	'pointChartCaption': 'Точечная диаграмма',
	'heatChartCaption': 'Тепловая карта',
	'bulletChartCaption': 'Диаграмма в виде схемы',
	'waterfallChartCaption': 'Каскадная диаграмма',
	'radarChartCaption': 'лепестковая диаграмма',
	'boxplotChartCaption': 'Коробчатая диаграмма',
	'pieChartCaption': 'Круговая диаграмма',
	'mapChartCaption': 'Карта',
	'radialBarChartCaption': 'Радиальный',
	'compositeChartCaption': 'Линия и столбец',
	'wordCloudChartCaption': 'Облако слов',
	'networkChartCaption': 'Сеть',
	'relationshipNetworkChartCaption': 'Сеть взаимосвязей',
	'treemapChartCaption': 'Карта дерева',
	'packedBubbleChartCaption': 'Упакованный пузырек',
	'hierarcicalPackedBubbleChartCaption': 'Пузырек иерархии',
	'spiralChartCaption': 'Спиральная диаграмма',
	'decisionTreeChartCaption': 'Дерево решений',
	'legacyMapChartCaption': 'Прежняя карта',
	'sunburstChartCaption': 'Солнечные лучи',
	'visUsageComparison': 'Сравнение',
	'visUsageRelationships': 'Взаимосвязи',
	'visUsageTrend': 'Тенденция',
	'visUsagePartsToWhole': 'Части к целому',
	'visUsageGeospatial': 'Геопространственные',
	'visUsageAdvanced': 'Расширенная аналитика',
	'visUsageTablesAndSummary': 'Таблицы и сводка',
	'visUsageSocialInsights': 'Социальное интуитивное понимание',
	'visUsageOther': 'Другое',
	'autoBinActionText': 'Автогруппировка',
	'filterAutobinActionText': 'Применить фильтр к контейнерам',
	'memberCalculationActionText': 'Вычисление члена',
	'toolbarActionCalculation': 'Создать вычисление',
	'toolbarActionEditCalculation': 'Изменить вычисление',
	'topBottomRankLabel': 'Ранг (%{label})',
	'toolbarDeleteFilterActionText': 'Удалить фильтр',
	'toolbarActionTopKeyDrivers': 'Показать факторы',
	'toolbarActionCustomGroup': 'Пользовательская группа',
	'canNotCreateCustomGroup': 'Не удается создать эту пользовательскую группу.',
	'aria_label_datatable': 'Таблица данных',
	'summaryCaption': 'Сводка',
	'MeasuresCaption': 'Показатели',
	'MeasuresGroupCaption': 'Группа показателей (%{count})',
	'ValuesCaption': 'Значения',
	'turnInsightsOn': 'Включить интуитивное понимание',
	'turnInsightsOff': 'Выключить интуитивное понимание',
	'decisionRules': 'Правила',
	'decisionTree': 'Диаграмма дерева',
	'decisionSunburst': 'Солнечные лучи дерева',
	'switchToDecisionRules': 'Переключиться на правила решений',
	'switchToDecisionTree': 'Переключиться на дерево решений',
	'data_group_less_then': 'меньше %{rangeTo}',
	'data_group_to': '%{rangeFrom} до < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} и выше',
	'nullValueContent': '(нет значения)',
	'sum': 'Сумма',
	'count': 'Число',
	'countdistinct': 'Подсчет уникальных',
	'avg': 'Среднее',
	'min': 'Минимум',
	'max': 'Максимум',
	'automatic': 'Настроить',
	'variance': 'Дисперсия',
	'stddev': 'Стандартное отклонение',
	'median': 'Медиана',
	'calculated': 'Вычисленный',
	'none': 'Нет',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Значения приглашений',
	'inputLabelPrompt': 'Значение',
	'inputPlaceholderPrompt': 'Введите значение',
	'inputInvalidText': 'Недопустимый ввод для типа %{dataType}',
	'unSupportedPrompt': 'Неподдерживаемое приглашение',
	'missingDataSource': 'Не удалось найти правильный источник данных.',
	'unSupportedPromptType': 'Сценарий приглашения в настоящее время не поддерживается.',
	'preAggregateLabel': 'Применить значения приглашений из источника данных',
	'postAggregateLabel': 'Применить значения приглашений в отчете',
	'preAggregateText': 'Для диапазона используются значения из источника данных, а не значения, отображаемые в сводной панели.',
	'defaultAggregation_count': 'Число',
	'defaultAggregation_countdistinct': 'Подсчет уникальных',
	'defaultAggregation_max': 'Максимум',
	'defaultAggregation_min': 'Минимум',
	'defaultAggregation_avg': 'Среднее',
	'defaultAggregation_sum': 'Сумма',
	'defaultAggregation_auto': 'Авто (%{aggregationType})',
	'keydriver_average': 'Общее среднее',
	'keydriver_up_down': 'Выделенные группы с высоким или низким средним значением оказывают большее влияние на объект назначения. Группы с необычно высоким или низким средним значением оказывают наиболее сильное влияние.',
	'keydriver_different': 'Распределение у выделенных групп существенно отличается от общего распределения. Эти группы оказывают большее влияние на объект назначения.',
	'topOperator': 'Вверху',
	'bottomOperator': 'Внизу',
	'topBottomFact': '%{operator} %{value}%{percent} по %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Удалить число первых или последних',
	'deleteTopBottomPercent': 'Удалить первые или последние %',
	'topBottomTitle': 'Только этот объект',
	'deleteTopBottom': 'Удалить число первых или последних',
	'editTopBottom': 'Изменить число первых или последних',
	'editTopBottomCount': 'Изменить число первых или последних',
	'editTopBottomPercent': 'Изменить первые или последние %',
	'ariaDeleteTopBottomCountLabel': 'Чтобы удалить число первых или последних, нажмите клавишу DELETE.',
	'ariaDeleteTopBottomPercentLabel': 'Чтобы удалить первые или последние %, нажмите клавишу DELETE.',
	'ariaEditTopBottomCountLabel': 'Чтобы изменить число первых или последних, нажмите клавишу ENTER.',
	'ariaEditTopBottomPercentLabel': 'Чтобы изменить первые или последние %, нажмите клавишу ENTER.',
	'ariaDeleteDrillStateLabel': 'Чтобы изменить число первых или последних, нажмите клавишу ENTER.',
	'drillUpStateTitle': 'Свернуть',
	'drillDownStateTitle': 'Детализировать данные',
	'ariaEditTopBottomLabel': 'Чтобы изменить число первых или последних, нажмите клавишу ENTER.',
	'ariaDeleteTopBottomLabel': 'Чтобы удалить число первых или последних, нажмите клавишу DELETE.',
	'allKeyDriversLabel': 'Автоматически (все драйверы)',
	'filter_drag_and_drop_single_dock': 'Перетащите сюда данные, чтобы применить фильтр.',
	'filter_drag_and_drop_all_tabs': 'Перетащите сюда данные, чтобы применить фильтр ко всем вкладкам.',
	'filter_drag_and_drop_current_tab': 'Перетащите сюда данные, чтобы применить фильтр к данной вкладке.',
	'filter_empty_consume_mode': 'Фильтры не применены.',
	'filterClearAllItems': 'Очистить все фильтры',
	'filterDeleteAllItems': 'Удалить все фильтры',
	'filterDockChevronLeft': 'Прокрутить данные',
	'filterDockChevronRight': 'Прокрутить данные',
	'filterIconLabel_Single': 'Фильтр',
	'filterIconLabel_Global': 'Все вкладки',
	'filterIconLabel_Tab': 'Данная вкладка',
	'filterIconTooltip_Single': 'Фильтр',
	'filterIconTooltip_Global': 'Фильтры для всех вкладок',
	'filterIconTooltip_Tab': 'Фильтры для этой вкладки',
	'filterDropZoneTooltip_Single': 'Зона сброса фильтра',
	'filterDropZoneTooltip_Global': 'Зона сброса фильтра для всех вкладок',
	'filterDropZoneTooltip_Tab': 'Зона сброса фильтра для данной вкладки',
	'filterOverflowMenu': 'Дополнительно',
	'expand': 'Развернуть',
	'collapse': 'Свернуть',
	'filterDockItemNameAriaLabel': 'Нажмите Enter, чтобы запустить диалоговое окно фильтра и задать фильтр.',
	'filterItemCanvasMove': 'Добавить на холст',
	'filterItemDelete': 'Удалить фильтр',
	'filterInvertRange': 'всё, кроме: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Не после %{from}',
	'filter_date_after': 'После %{from}',
	'filter_date_before_except': 'Не раньше %{to}',
	'filter_date_before': 'До %{to}',
	'filter_date_between_except': 'Не между %{from}-%{to}',
	'filter_date_between': 'Между %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Все',
	'filter': 'Фильтр',
	'filterExcept': 'кроме %{values}',
	'filterDockToolbarButtonLabel': 'Док фильтров',
	'navigateTitle': 'Перейти к',
	'navigateSelectColumn': 'Выбрать столбец',
	'navigateSelectPath': 'Выберите путь навигации',
	'current_nav_group': 'Текущая группа навигации - %{navigation_group_name}',
	'next': 'Следующая',
	'previous': 'Предыдущее',
	'multiselectMsg': '%{count} выбрано',
	'errMsgFilterItemMissingTitle': 'Невозможно загрузить значения фильтра %{itemName}, так как эти значения недоступны для этого набора данных',
	'errMsgFilterItemGenericTitle': 'Не удается загрузить значения фильтра',
	'textFilterItemsNotFound': 'Нет доступных элементов.',
	'nullValueLabel': '(пустой)',
	'filterConditionLabel': 'Условие фильтра',
	'filter_includesAll': 'Включить все',
	'filter_allMembersOfSet': 'Все члены набора',
	'modelFilter': 'Фильтр',
	'filtersTitle': 'Свойства фильтра',
	'search': 'Поиск',
	'clearTextFilterValue': 'Очистить',
	'invertFilterSelection': 'Инверсия',
	'modellingLoading': 'Загрузка...',
	'searchAll': 'Найти все столбцы',
	'toolbarActionPossibleKeyDrivers': 'Изменить область',
	'toolbarActionPossibleKeyDriversSubTitle': 'Перетащите элементы слева для рассмотрения на диаграмме анализа драйвера.',
	'toolbarActionSort': 'Сортировать',
	'toolbarActionSortAscending': 'По восходящей',
	'toolbarActionSortDescending': 'По нисходящей',
	'toolbarActionSortAuto': 'Авто (%{sortOrder})',
	'toolbarActionSortCustom': 'Настроить',
	'toolbarActionFormat': 'Данные формата',
	'toolbarActionFormatText': 'Данные о формате (текст)',
	'toolbarActionFormatAbbreviation': 'Сокращать',
	'toolbarActionFormatNone': 'Автоматически',
	'toolbarActionFilter': 'Фильтр',
	'toolbarActionTopBottom': 'Первые или последние',
	'toolbarActionRmvShape': 'Удалить форму',
	'toolbarActionToggleShapeDrop': 'Инфографическая форма',
	'toolbarActionToggleShapeDropTitle': 'Создать инфографику',
	'toolbarActionToggleShapeDropText': 'Перетащите в это поле форму, чтобы создать инфографику.',
	'toolbarActionAggregationType': 'Суммировать',
	'toolbarDeleteActionText': 'Удалить столбец',
	'toolbarTextActionText': 'Текст стиля',
	'toolbarActionFilterLocalKeepSelected': 'Оставить',
	'toolbarActionFilterLocalExcludeSelected': 'Исключить',
	'toolbarActionFilterAllKeepSelected': 'Фильтр',
	'toolbarActionSimpleCalculation': 'Простое вычисление',
	'toolbarActionDrillBack': 'Назад',
	'toolbarActionDrillUp': 'Свернуть',
	'toolbarActionDrillDown': 'Детализировать данные',
	'toolbarActionJumpTo': 'Детализация',
	'toolbarActionNavigate': 'Обзор',
	'toolbarActionCreateFilterGroup': 'Создать новое соединение',
	'toolbarActionDisconnectFilterGroup': 'Разорвать все ссылки',
	'toolbarActionLinkFilterGroup': 'Добавить к существующему соединению',
	'toolbarActionLassoSelect': 'Выберите инструмент',
	'toolbarActionRefreshDeveloperWidget': 'Обновить',
	'textFontFamilySubClassHairline': 'С засечками',
	'textFontFamilySubClassThin': 'Тонкий',
	'textFontFamilySubClassThinItalic': 'Тонкий курсив',
	'textFontFamilySubClassExtraLight': 'Сверхсветлый',
	'textFontFamilySubClassExtraLightItalic': 'Сверхсветлый курсив',
	'textFontFamilySubClassLight': 'Светлый',
	'textFontFamilySubClassLightItalic': 'Светлый курсив',
	'textFontFamilySubClassRegular': 'Нормальный',
	'textFontFamilySubClassRegularItalic': 'Нормальный курсив',
	'textFontFamilySubClassItalic': 'Курсив',
	'textFontFamilySubClassMedium': 'Средний',
	'textFontFamilySubClassMediumItalic': 'Средний курсив',
	'textFontFamilySubClassHeavy': 'Плотный',
	'textFontFamilySubClassHeavyItalic': 'Плотный курсив',
	'textFontFamilySubClassDemiBold': 'Полужирный',
	'textFontFamilySubClassDemiBoldItalic': 'Полужирный курсив',
	'textFontFamilySubClassBold': 'Полужирный',
	'textFontFamilySubClassBoldItalic': 'Жирный курсив',
	'textFontFamilySubClassExtraBold': 'Сверхжирный',
	'textFontFamilySubClassExtraBoldItalic': 'Сверхжирный курсив',
	'textFontFamilySubClassBlack': 'Черный',
	'textFontFamilySubClassBlackItalic': 'Черный курсив',
	'textFontFamilySubClassStencil': 'Трафарет',
	'dlg_ascending': 'по восходящей',
	'dlg_descending': 'по нисходящей',
	'dlg_custom': 'настраиваемые',
	'dlg_none': 'нет',
	'dlg_hierarchy': 'иерархия',
	'dlg_namedSet': 'именованный набор',
	'dlg_rank': 'ранг',
	'visualizationLabel': 'Визуализация',
	'chartLabel': 'Диаграмма %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Чтобы перемещаться по виджету, нажмите F12',
	'f10KeyDescription': 'Нажмите F10, чтобы запустить представление фокуса виджета',
	'playButtonLabel': 'Воспроизвести',
	'dataPlayerValueListLabel': 'Значения плеера данных',
	'localFilterTitle': 'Только этот объект',
	'globalFilterTitle': 'Все объекты',
	'deleteFilter': 'Удалить фильтр',
	'editFilter': 'Изменить фильтр',
	'ariaEditFilterLabel': 'Чтобы изменить фильтр, нажмите клавишу ENTER.',
	'ariaDeleteFilterLabel': 'Чтобы удалить фильтр, нажмите клавишу DELETE.',
	'measureFilterBetween': 'Между %{lowerBound} и %{upperBound}',
	'measureFilterNotBetween': 'Не между %{lowerBound} и %{upperBound}',
	'dimFilterIn': 'Включает: %{in}',
	'dimFilterNotIn': 'Исключает: %{out}',
	'gtFilter': 'После %{lowerBound}',
	'ltFilter': 'До %{upperBound}',
	'ariaEditPrompt': 'Чтобы изменить значение приглашения, нажмите клавишу ENTER',
	'dataPointFilterTitle': 'Точки данных',
	'dataPointFilterIncludeSummary': 'Включены точки данных: %{valueCount}',
	'dataPointFilterExcludeSummary': 'Исключены точки данных: %{valueCount}',
	'widgetFiltersLabel': 'Фильтры виджета',
	'coachMarkTitleSpiralTarget': 'Изменить область',
	'coachMarkContentSpiralTarget': 'Здесь можно получить доступ и изменить выбор драйвера для целевого объекта.',
	'srILVTreeLabel': 'Список',
	'geomapUnrecognizedLocations': 'Нераспознанные положения:',
	'geomapAmbiguousLocations': 'Неоднозначные регионы:',
	'visualizationNotifications': 'Уведомления визуализации:',
	'dataNotifications': 'Уведомления о данных:',
	'autobinSuggestion': 'Включить автогруппировку',
	'LIVE_empty_visualization_hint_title': 'Построить свою собственную визуализацию',
	'LIVE_empty_visualization_hint_description': 'Перетащите данные сюда или на поля.',
	'LIVE_slots_required_field_description': '%{asterisk} Указывает обязательное поле',
	'LIVE_slots_drag_and_drop_description': 'Перетащите данные на находящиеся выше поля, чтобы построить визуализацию и применить к ней фильтр.',
	'dwErrorLoadingAvailableVisualizations': 'Мы не можем загрузить доступные определения визуализации',
	'moreDataIndicator': 'Ваши данные обрезаны на уровне %{threshold} элементов. Примените фильтр, чтобы показать меньше данных.',
	'nonCtxTopBottomInvalid': 'Определение верхнего или нижнего правила без контекста для перекрестных таблиц не поддерживается. Удалено из этого представления перекрестной таблицы.  Переопределите правило для одной или нескольких категорий в контексте %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'Мы не можем загрузить объект, та как у него отсутствует определение визуализации.',
	'dwErrorLoadingVisualizationListNotFound': 'Мы не можем загрузить визуализацию.',
	'dwErrorRunningQuery': 'Мы не можем получить данные из набора данных %{datasetName}.',
	'dwErrorGeoData': 'У нас возникли затруднения при выводе географических данных на карте. Выберите другой тип визуализации.',
	'dwPromptSignonCancelWarning': 'Данные для этой визуализации недоступны. Введите правильные учетные данные.',
	'dwErrorMissingDataset': 'Мы не можем загрузить визуализацию, так как связанный набор данных "%{datasetName}" недоступен.',
	'dwErrorRenderingVisualization': 'Мы не можем загрузить эту визуализацию.',
	'dwErrorVisualizationTooSmall': 'Визуализация слишком мала, чтобы показать содержащиеся в ней данные. Сделайте визуализацию больше или ограничьте содержащиеся в ней данные.',
	'errorSourceNotFound': 'Мы не можем загрузить визуализацию, так как связанный источник "%{sourceName}" недоступен.',
	'errorActionNotSupported': 'Это действие не поддерживается для источника данных "%{sourceName}".',
	'errorMeasureNotSupportedOnMultiEdges': 'На визуализации присутствуют показатели по нескольким краям, что больше не поддерживается. Поместите показатели только на одном краю.',
	'errorExceedAllowableValue': 'Расчетное количество ячеек превышает допустимое значение 100000. Примените фильтрацию к проецируемым наборам, чтобы уменьшить число ячеек.',
	'propScaleLabel': 'Количество значков',
	'propScaleDescription': 'Выберите количество значков',
	'propScaleFew': 'Низкий',
	'propScaleDefault': 'По умолчанию',
	'propScaleMany': 'Высокий',
	'lastRefresh': 'Последнее обновление: %{timeInterval} тому назад',
	'widgetTimer': 'Таймер виджета',
	'datasetItemsUnavailable': 'Некоторые элементы набора данных, используемые в этой визуализации, недоступны.',
	'datasetItemUnavailable': 'Этот элемент набора данных недоступен.',
	'retry': 'Повторить',
	'widgetConditionalFormatLabel': 'Переключить элементы управления условным форматом',
	'widgetConditionalFormatTitle': 'Изменить цвет условного форматирования',
	'crosstabName': 'Перекрестная таблица',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'Неприменимо',
	'summaryLabel': '%{label} со значением %{value}',
	'infographicLabel': '%{label} со значением %{value}',
	'warning': 'Предупреждение',
	'swapRowsAndColumns': 'Поменять местами строки и столбцы',
	'hideSummariesLabel': 'Скрыть сводки',
	'showSummariesLabel': 'Показать сводки',
	'hideRowColumn': 'Скрыть',
	'showAllRowColumn': 'Показать все',
	'dataAssetPropertiesLabel': 'Свойства визуализации',
	'evAdd': 'Добавить столбец',
	'evCollapse': 'Свернуть',
	'evColumns': 'Столбцы',
	'evLocalFilters': 'Локальные фильтры',
	'evExpand': 'Развернуть',
	'evFilterTooltip': 'Фильтр',
	'missingColumn': 'Отсутствует: %{columnLabel}',
	'missingFiltering': 'Отсутствуют фильтры для столбцов:',
	'missingDataItem': 'Элемент данных "%{dataItemId}", на который имеется ссылка, не найден в виджете.',
	'heatByLabel': 'Тепло по',
	'toolbarChangeVisualization': 'Изменить визуализацию',
	'modellingRelatedTablesNoneFound': 'Не найдено никаких связанных таблиц',
	'processing': 'Обработка...',
	'errorCellWarning': 'Не удалось вычислить некоторые сводные значения.',
	'aggregateTypeToggler': 'Показать тип агрегации',
	'maxColumnsExceeded': 'Превышено максимальное число столбцов. %{columns} отброшен.',
	'unboundColumns': 'Не удается использовать следующие столбцы: %{columns}.',
	'unboundColumn': 'Не удалось использовать следующий столбец: %{columns}.',
	'recommendRequestFailed': 'Требование рекомендации завершилось неудачно. Обратитесь к администратору.',
	'visualizationDoesNotSupportOLAP': 'Мы не можем создать эту визуализацию, основанную на источнике данных OLAP. Выберите другой поддерживаемый источник данных.',
	'showDataBehindVizLabel': 'Показать данные',
	'showDataBehindVizNotSupportedLabel': 'Опция Показать данные не поддерживаются для этого типа визуализации',
	'exploreData': 'Исследовать...',
	'newExplore': 'Новое исследование',
	'thumbnails_error_fetching': 'Ошибка при получении миниизображений',
	'loadedThumbnailImage': 'Загружено миниизображение визуализации %{visType}',
	'autobinAxisLabel': 'группы',
	'recommended_visualizations': 'Рекомендуемые визуализации',
	'all_visualizations': 'Все визуализации',
	'edit': 'Изменить',
	'selectTargetDialogTitle': 'Выбрать объект назначения детализации',
	'noTargetInCM': 'Невозможно найти объект назначения детализации',
	'errorDrillDefinition': 'Что-то пошло не так, пока вы добавляли или редактировали определение детализации.',
	'errorDrillToTarget': 'Произошла ошибка при детализации до "%{targetName}"',
	'drillThroughMappingViewLabel': 'Назначить столбцы из сводной панели для приглашений отчета назначения',
	'drillthroughScopeRadioLabel': 'Применить это определение к:',
	'drillthroughScopeRadioOptionVisualization': 'Только этой визуализации',
	'drillthroughScopeRadioOptionConnection': 'Визуализациям в том же самом соединении, использующим тот же самый источник данных',
	'drillthroughScopeRadioOptionDashboard': 'Любая визуализация в %{perspective}, использующая один и тот же источник данных',
	'drillThroughParametersColumnTitle': 'Приглашения "%{targetName}":',
	'drillThroughMetadataColumnTitle': 'Столбцы данных "%{boardName}":',
	'drillThroughDefinitionNoParameter': 'У целевого объекта детализации нет приглашений.',
	'drillThroughDefinitionErrorQueryingReport': 'Исправьте ошибку в отчете назначения, а затем вновь попытайтесь создать определение детализации.',
	'drillThroughDefinitionErrorDlgTitle': 'Что-то пошло не так',
	'dlg_back': 'Перейти назад',
	'dlg_close': 'Закрыть',
	'dlg_ok': 'ОК',
	'dlg_cancel': 'Отмена',
	'dlg_apply': 'Применить',
	'dlg_create': 'Создать',
	'dlg_done': 'Готово',
	'drillthrough_unsaveMsg': 'Продолжить без сохранения "%{name}"?',
	'drillthrough_jumpTo': 'Определение детализации: %{name}',
	'drillthrough_jumpToLabel': 'Детализация',
	'drillthrough_manage': 'Управление...',
	'drillthrough_addNewTarget': 'Добавить новое определение детализации',
	'drillthrough_manageJumpPaths': 'Управление определениями детализации',
	'drillthrough_manageJumpPaths_edit': 'Правка "%{name}"',
	'drillthrough_manageJumpPaths_delete': 'Удалить "%{name}"',
	'drillthrough_manageAddAnotherTarget': 'Добавить другое определение детализации',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Подтвердить удаление',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Вы уверены, что хотите удалить детализацию "%{name}"?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Дубликат имени детализации',
	'drillthrough_definitionMessage': 'Детализация "%{name}" уже существует. Задайте другое имя.',
	'drillthrough_jumpToTarget_notFound': 'Не найден объект назначения для детализации "%{name}"',
	'drillThroughDefinitionNoParameterSubTitle': 'В целевой отчет не будет передан контекст.',
	'drillthrough_titleLabel': 'Имя',
	'drillthrough_create_dialogTitle': 'Создание определения детализации',
	'drillthrough_edit_dialogTitle': 'Правка определения детализации',
	'drillthrough_subTitle': 'Контекст визуализации в источнике используется для применения фильтра к целевому %{perspective}.',
	'drillthrough_selectColumn': 'Выбрать столбец',
	'noPrompt': 'Без приглашений',
	'promptDialog': 'Диалоговое окно приглашения %{promptType}',
	'formatAutoDescription': 'Автоматически задает формат, унаследованный от источника данных или визуализации',
	'formatDefaultDescription': 'Значение по умолчанию - формат, унаследованный от системы',
	'createCustomGroupAction': 'Создать группу данных',
	'removeCustomGroupAction': 'Удалить группу данных',
	'editCustomGroupAction': 'Изменить группу данных',
	'renameCustomGroupAction': 'Переименовать группу данных',
	'createCustomGroupErrorToast': 'Невозможно создать вашу группу данных.',
	'removeCustomGroupErrorToast': 'Невозможно удалить вашу группу данных.',
	'editCustomGroupErrorToast': 'Невозможно изменить вашу группу данных.',
	'renameCustomGroupErrorToast': 'Невозможно переименовать вашу группу данных.',
	'customGroupLabel': 'Создать группу данных',
	'ungroupCustomGroupLabel': 'Разгруппировать',
	'renameCustomGroupLabel': 'Переименовать',
	'createCustomGroupLabel': 'Создать',
	'customGroupingLabel': '%{columnLabel} (Группа)',
	'createCustomSort': 'Создать пользовательскую сортировку',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Выберите доступные элементы и переупорядочите их, чтобы создать пользовательскую сортировку.',
	'availableItems': 'Доступные элементы',
	'selectAll': 'Выбрать все',
	'customSortOrder': 'Пользовательский порядок сортировки',
	'selectAvailableItemsDesc': 'Выберите доступные элементы и переупорядочите их здесь.',
	'moveToTop': 'Перейти наверх',
	'clear': 'Очистить',
	'sortRemainingItemsBy': 'Сортировать остальные элементы по',
	'removeAll': 'Удалить все',
	'resetTooltip': 'Все элементы будут удалены из списка %{customSortOrder}. И выпадающее меню %{sortRemainingItemsBy} вернется к значению по умолчанию.',
	'manyItemsWarning': 'Выбор нескольких пунктов может повлиять на производительность вашей сводной панели.',
	'manyItemsSelected': 'Выбрано больше %{maxItems} элементов, это может повлиять на производительность вашей сводной панели.',
	'somethingWentWrong': 'Ой-ой. Что-то здесь не так.',
	'tryAgain': 'Попробуйте еще раз',
	'customSortLabel': 'Пользовательская сортировка',
	'applyError': 'Не удается применить %{action}.',
	'searchReturnedNoResults': 'Хм, ваш поиск не дал никаких результатов.',
	'extVisSystem': 'Система',
	'extVisCustom': 'Настроить',
	'customVisTestVisualization': 'Протестировать визуализацию',
	'extVisCustomVisPreview': 'предварительный просмотр',
	'extVisCustomPreviewWidgets': 'Виджеты разработчика',
	'extVisCustomVVisualization': 'Визуализация',
	'extVisCustomVisuals': 'Пользовательская визуализация',
	'noPermissionToManage': 'У вас нет разрешения на управление пользовательскими визуализациями.',
	'extVisCustomUpdate': 'Обновить',
	'extVisCustomDelete': 'Удалить',
	'extVisNoCustomVisuals': 'Нет пользовательских визуальных элементов',
	'extVisNoCustomVisualsMsg': 'В настоящее время в вашей организации нет пользовательских визуализиций',
	'extVisAddCustomVisual': 'Добавить пользовательскую визуализацию',
	'extVisNoCustomVisualsAdminMsg': 'Сейчас нет пользовательских визуальных элементов. Добавьте один, чтобы начать',
	'extVisNoSDKConnection': 'Соединение с локальным файлом не установлено',
	'extVisNoSDKPreviewMsg': 'Для предварительного просмотра визуализаций установите соединение.',
	'extVisMore': 'Дополнительно',
	'extVisDeleteDialogTitle': 'Удалить пользовательский визуальный элемент',
	'extVisDeleteDialogBody': 'Вы уверены, что хотите удалить эту пользовательскую визуализацию? Возможно, она используется другими сводными панелями и отчетами.',
	'extVisDeleteConfirmation': 'Пользовательский визуальный элемент удален.',
	'extVisDeleteError': 'Не получилось удалить пользовательский визуальный элемент. %{msg}',
	'extVisCloseToast': 'Закрыть сейчас',
	'extVisAdd': 'Ваш визуальный визуальный элемент успешно добавлен.',
	'extVisAddError': 'Не удалось добавить пользовательский визуальный элемент. %{msg}',
	'extVisUpdate': 'Ваш визуальный визуальный элемент успешно обновлен.',
	'extVisUpdateError': 'Не удалось обновить пользовательский визуальный элемент. %{msg}',
	'extVisAddProgress': 'Импорт %{name}',
	'extVisUpdateProgress': 'Обновление %{name}',
	'extPermissionTitle': 'Ограниченный доступ или удаленная пользовательская визуализация',
	'extPermissionBody': 'Эту пользовательскую визуализацию невозможно просмотреть, так как либо она была удалена, либо она имеет ограниченный доступ.',
	'customVizSaveWarning': 'Не удается сохранить пользовательские визуальные элементы. Они не импортированы.',
	'schematicTestCaption': 'Проверить схематическое представление',
	'schematicServiceRequestError': 'Ошибка схематической службы',
	'extVisPreviewMessage': 'Это предварительный просмотр. Визуализация еще не добавлена в продукт.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Не задан',
	'kpiDefaultTargetLabel': 'Целевой объект',
	'kpiNonNumericTarget': 'Целевое значение должно быть числом.',
	'kpiManualTargetSlotFilled': 'Значение, примененное в поле',
	'kpiAutoValueSize': 'Автоматически',
	'kpiUnableDrawSparklineLabel': 'Не удалось нарисовать спарклайн',
	'kpiUnableDrawSparklineInfo': 'Для спарклайна требуется как минимум два момента времени. Измените данные или настройте фильтры для просмотра спарклайна.',
	'conditionalFormattingTextColor': 'Цвет текста',
	'suppression': 'Подавление',
	'suppressNone': 'Нет',
	'suppressRowsAndColumns': 'Строки и столбцы',
	'suppressRows': 'Строки',
	'suppressColumns': 'Столбцы',
	'enableSuppression': 'Включить подавление',
	'disableSuppression': 'Выключить подавление',
	'loadVisDefinitionError': 'Не удается загрузить определение для визуализации %{id}',
	'emptyVisualization': 'Пустая визуализация',
	'expandCollapse': 'Развернуть и свернуть',
	'expandBtnLabel': 'Развернуть',
	'collapseBtnLabel': 'Свернуть',
	'prop_sizeInputNonNumericValue': 'Значение должно быть числом.',
	'prop_sizeValueShouldBeHigher': 'Это значение должно быть больше %{value}.',
	'fontPropLabel': 'Семейство шрифтов',
	'fontSizePropLabel': 'Размер шрифта',
	'sectionItemAxisTitle': 'Заголовок оси элементов',
	'sectionItemAxisLabel': 'Метка оси элементов',
	'sectionValueAxisTitle': 'Заголовок оси значений',
	'sectionValueAxisLabel': 'Метка оси значений',
	'styletext-widget.legend': 'Легенда',
	'styletext-itemAxis.ticks.labels': 'Метки осей',
	'styletext-valueAxis.title': 'Заголовки осей',
	'styletext-itemAxis.title': 'Заголовки осей',
	'styletext-labels': 'Метки данных',
	'styletext-valueAxis.line.title': 'Заголовки строк',
	'styletext-cellValue': 'Значения',
	'styletext-values': 'Значения',
	'styletext-rowHeading': 'Заголовки строк',
	'styletext-columnHeading': 'Заголовки столбцов',
	'fontFamily': 'семейство',
	'fontSize': 'размер',
	'visExportFileName': 'Визуализация',
	'ds-missingDataSet': 'Не удалось найти набор данных. Убедитесь, что набор данных создан.',
	'ds-missingDashboardId': 'Сохраните сводную панель, прежде чем создавать набор данных.',
	'ds-unsupportedDataSourceType': 'Тип источника данных %{type} не поддерживается.',
	'dataCache': 'Кэш данных',
	'dataCache_on': 'Включено',
	'dataCache_off': 'Без кэша',
	'dataCache_auto': 'Автоматически',
	'queryOptimization': 'Оптимизация запроса'
});
